module.exports = "input.ng-invalid.ng-touched {\r\n\tborder: 1px solid red;\r\n}\r\n.btn[disabled] {\r\n\tcursor: not-allowed;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/signup-modal/signup-modal.component.css
// module id = ./src/app/signup-modal/signup-modal.component.css
// module chunks = main